<template>
  <div
    class="col-12 q-gutter-md"
    :class="{'col-8': $q.screen.lt.sm}"
  >
    <div v-if="displayGoogle">
      <universal-tooltip
        :text="disableTooltip"
        :show-tooltip="disableTooltip && (disableGoogle || disable)"
        anchor="top middle"
        :offset="[0,40]"
      >
        <hr-provider-btn
          logo-src="google-auth-192x192.png"
          :label="googleLabel"
          :loading="isGoogleLoading"
          :disable="disableGoogle || disable"
          @click="onGoogleClick"
        />
      </universal-tooltip>
    </div>
    <div v-if="displayMicrosoft">
      <universal-tooltip
        :text="disableTooltip"
        :show-tooltip="disableTooltip && (disableMicrosoft || disable)"
      >
        <hr-provider-btn
          logo-src="microsoft-auth.png"
          :label="microsoftLabel"
          :loading="isMicrosoftLoading"
          :disable="disableMicrosoft || disable"
          @click="onMicrosoftClick"
        />
      </universal-tooltip>
    </div>
    <div v-if="displayApple && !isNativeAndroid">
      <universal-tooltip
        :text="disableTooltip"
        :show-tooltip="disableTooltip && (disableApple || disable)"
      >
        <hr-provider-btn
          icon="fab fa-apple"
          :label="appleLabel"
          :loading="isAppleLoading"
          :disable="disableApple || disable"
          @click="onAppleClick"
        />
      </universal-tooltip>
    </div>
  </div>
</template>

<script>

import UniversalTooltip from 'components/UI/UniversalTooltip.vue';
import { HrProviderBtn } from 'src/design-system';

const MODE = {
  SIGN_IN: 'sign-in',
  SIGN_UP: 'sign-up',
  RE_AUTHENTICATE: 're-auth',
};

export default {
  name: 'ProviderAuthorizationButtons',

  components: {
    HrProviderBtn,
    UniversalTooltip,
  },

  props: {
    /** Should display Google sign-in button */
    displayGoogle: {
      type: Boolean,
      default: true,
    },

    /** Should display Apple sign-in button */
    displayApple: {
      type: Boolean,
      default: true,
    },

    /** Should display Microsoft sign-in button */
    displayMicrosoft: {
      type: Boolean,
      default: true,
    },

    /** Disable Google sign-in button */
    disableGoogle: {
      type: Boolean,
      default: false,
    },

    /** Disable Apple sign-in button */
    disableApple: {
      type: Boolean,
      default: false,
    },

    /** Disable Apple sign-in button */
    disableMicrosoft: {
      type: Boolean,
      default: false,
    },

    /** Disable all sign-in buttons */
    disable: {
      type: Boolean,
      default: false,
    },

    /** Tooltip text that will be shown on hover the disabled button */
    disableTooltip: {
      type: String,
      default: '',
    },

    /** Google sign-in button loader */
    isGoogleLoading: {
      type: Boolean,
      default: false,
    },

    /** Apple sign-in button loader */
    isAppleLoading: {
      type: Boolean,
      default: false,
    },

    isMicrosoftLoading: {
      type: Boolean,
      default: false,
    },

    /** Component mode changes the buttons labels */
    mode: {
      type: String,
      default: MODE.SIGN_IN,
    },
  },

  emits: ['google-click', 'apple-click', 'microsoft-click'],

  computed: {
    appleLabel() {
      if (this.mode === MODE.SIGN_UP) {
        return this.$t('signup.signupComponent.buttonAppleSignup');
      }

      if (this.mode === MODE.RE_AUTHENTICATE) {
        return this.$t('users.modals.reAuthenticate.buttonReAuthenticateWithApple');
      }

      return this.$t('loginSSO.buttonLoginApple');
    }, // appleLabel()

    googleLabel() {
      if (this.mode === MODE.SIGN_UP) {
        return this.$t('signup.signupComponent.buttonGoogleSignup');
      }

      if (this.mode === MODE.RE_AUTHENTICATE) {
        return this.$t('users.modals.reAuthenticate.buttonReAuthenticateWithGoogle');
      }

      return this.$t('loginSSO.buttonLoginGoogle');
    }, // googleLabel()

    microsoftLabel() {
      if (this.mode === MODE.SIGN_UP) {
        return this.$t('signup.signupComponent.buttonMicrosoftSignup');
      }

      if (this.mode === MODE.RE_AUTHENTICATE) {
        return this.$t('users.modals.reAuthenticate.buttonReAuthenticateWithGoogle');
      }

      return this.$t('loginSSO.buttonLoginMicrosoft');
    }, // microsoftLabel()

    isNativeAndroid() {
      return this.$q.platform.is.capacitor && this.$q.platform.is.android;
    }, // isNativeAndroid()

  },

  methods: {
    onGoogleClick() {
      this.$emit('google-click');
    }, // onGoogleClick()

    onAppleClick() {
      this.$emit('apple-click');
    }, // onAppleClick()

    onMicrosoftClick() {
      this.$emit('microsoft-click');
    }, // onMicrosoftClick()
  },
};
</script>
<style scoped>
.hr-provider-btn {
  width: 100%;
}

</style>
